import React, { useState } from "react";

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      q: "What is the typical delivery timeline?",
      a: "Domestic deliveries usually take 3–10 days, while international shipments may take 15–45 days depending on customs clearance, destination, and carrier availability."
    },
    {
      q: "Do you offer refunds?",
      a: "Refunds are only available before shipment pickup or if eligibility criteria are met. Completed deliveries are non-refundable. All claims must follow our Refund & Payment Policy."
    },
    {
      q: "What items are restricted or prohibited?",
      a: "Hazardous materials, chemicals, illegal goods, counterfeit items, perishable goods without arrangement, and any items restricted by CBP or airline regulations cannot be shipped."
    },
    {
      q: "How do I track my shipment?",
      a: "Once your shipment is processed, a tracking number will be sent via email or SMS for real-time updates."
    },
    {
      q: "Do you provide shipment insurance?",
      a: "Yes, optional insurance coverage is available upon request for high-value shipments."
    },
    {
      q: "How can I avoid shipment delays?",
      a: "Provide accurate addresses, correct documentation, avoid restricted items, and ensure customs information is accurate for international shipments."
    }
  ];

  return (
    <>
      <style>{`
        .faq-section {
          padding: 80px 0;
          background: #f7f9ff;
        }

        .faq-title {
          text-align: center;
          font-size: 32px;
          font-weight: 900;
          margin-bottom: 40px;
        }

        .faq-item {
          background: #fff;
          border-radius: 14px;
          padding: 18px 22px;
          margin-bottom: 15px;
          box-shadow: 0 8px 22px rgba(0,0,0,0.07);
          cursor: pointer;
          transition: 0.25s ease;
          border-left: 5px solid #005eff;
        }

        .faq-item:hover {
          transform: translateY(-3px);
        }

        .faq-question {
          font-size: 18px;
          font-weight: 700;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .faq-icon {
          font-size: 22px;
          transition: transform 0.3s ease;
        }

        .faq-icon.open {
          transform: rotate(180deg);
        }

        .faq-answer {
          font-size: 15px;
          color: #444;
          line-height: 1.6;
          margin-top: 12px;
          animation: fadeDown 0.35s ease;
        }

        @keyframes fadeDown {
          0% { opacity: 0; transform: translateY(-8px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      <section className="faq-section">
        <div className="container">
          <h2 className="faq-title">Frequently Asked Questions</h2>

          {faqs.map((item, i) => (
            <div 
              key={i} 
              className="faq-item"
              onClick={() => toggleFAQ(i)}
            >
              <div className="faq-question">
                {item.q}
                <span className={`faq-icon ${openIndex === i ? "open" : ""}`}>
                  ▼
                </span>
              </div>

              {openIndex === i && (
                <div className="faq-answer">
                  {item.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
